import { render, staticRenderFns } from "./ProfitMktUsers.vue?vue&type=template&id=2b2c228e&"
import script from "./ProfitMktUsers.vue?vue&type=script&lang=ts&"
export * from "./ProfitMktUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports